import { Button, Flex } from "@eworkit/iris";
import { FieldArray, FormikProps } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

import { VALIDATION_TYPES } from "@/components/Formik";
import { ELABORATION_MAX_LENGTH } from "@/data/job-applications";
import { JobApplication } from "@/data/job-applications/types/JobApplication";
import { AnswerFormValues, ApplyQuestion } from "@/views/job-applications/apply/_questionnaire/ApplyQuestion";

import { useApplyWizardDraftUpdate } from "../_components/useApplyWizardDraftUpdate";

export const questionnaireValidation = Yup.object()
  .required()
  .shape({
    answers: Yup.array().of(
      Yup.object().shape({
        answer: Yup.mixed().when("question.mandatory", {
          is: true,
          then: Yup.mixed().oneOf([true, false], VALIDATION_TYPES.REQUIRED),
        }),
        elaboration: Yup.mixed().when("answer", {
          is: true,
          then: Yup.string()
            .trim()
            .required(VALIDATION_TYPES.REQUIRED)
            .max(ELABORATION_MAX_LENGTH, VALIDATION_TYPES.MAX_LENGTH),
          otherwise: Yup.string().trim().max(ELABORATION_MAX_LENGTH, VALIDATION_TYPES.MAX_LENGTH),
        }),
      }),
    ),
  });

export const transformDraftWithQuestionnaire = (values: AnswerFormValues) => (draft: JobApplication) => ({
  ...draft,
  answers: values.answers ? values.answers : [],
});

interface IJobRequestApplyQuestionnaireSectionProps {
  formik: FormikProps<AnswerFormValues>;
}

export const ApplyQuestionnaireForm: FC<IJobRequestApplyQuestionnaireSectionProps> = ({ formik }) => {
  const { t } = useTranslation("session");

  useApplyWizardDraftUpdate(transformDraftWithQuestionnaire(formik.values));

  return (
    <>
      <FieldArray name="answers">
        {arrayHelpers => (
          <Flex gap="md" flexDirection="column">
            {formik.values.answers?.map((answer, index) => (
              <ApplyQuestion key={index} answer={answer} name={`${arrayHelpers.name}.${index}`} form={formik} />
            ))}
          </Flex>
        )}
      </FieldArray>
      <Flex>
        <Button onClick={formik.submitForm} disabled={formik.isSubmitting} size="lg">
          {t("JOB_REQUESTS.APPLY.WIZARD.CONTINUE")}
        </Button>
      </Flex>
    </>
  );
};
